import { SideDrawer } from "../../../shared/SideDrawer";
import { EmployerFundLedger } from "../../../../models/funding/employerFundLedger";
import { Box, Stack, Typography } from "@mui/material";
import { useData } from "../../../../utils/useData";
const LoadFeeInfoSideDrawer = ({ ledger, isOpen, setIsOpen } : { 
    ledger: EmployerFundLedger | null, isOpen: boolean, setIsOpen: (isOpen: boolean) => void 
}) => {
    const { plans } = useData();
    return (
        <SideDrawer
            title="Load Fee Info"
            open={isOpen}
            setIsOpen={setIsOpen}
        >
            <Stack spacing={3} mx={2}>
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        Assigned Plan Name
                    </Typography>
                    <Typography variant="body1">
                        {plans.data?.items.find(p => p.id === ledger?.loadFeeMetadata?.planId)?.name}
                    </Typography>
                </Box>
            </Stack>
        </SideDrawer>
    )
}

export default LoadFeeInfoSideDrawer;